const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const UNSAFE_EMAIL = /[\s<>'"\\]|javascript:|data:/i;
const TEL_PATTERN = /^[+()0-9. -]{7,22}$/;

export const mailtoHref = (email: string): string | undefined => {
    const trimmed = String(email || '').trim();
    if (!EMAIL_PATTERN.test(trimmed) || UNSAFE_EMAIL.test(trimmed)) {
        return undefined;
    }
    return `mailto:${trimmed}`;
};

export const telHref = (phone: string): string | undefined => {
    const trimmed = String(phone || '').trim();
    if (!TEL_PATTERN.test(trimmed)) {
        return undefined;
    }
    return `tel:${trimmed}`;
};
